export module Util {
    export class Util {
        hasGroupPermission(user: User, groupUuid: string, permission: string) {
            return user.groupMemberships?.find(m => m.groupUuid == groupUuid && m.permissions!.includes(permission))
        }
    
        hasPermissionInAnyGroup(user: User, permission: string) {
            return user.groupMemberships?.find(m => m.permissions!.includes(permission))
        }
    
        hasPermissionInPrimaryGroup(user: User, permission: string) {
            if (!user.primaryGroupUuid) return false
            return this.hasGroupPermission(user, user.primaryGroupUuid, permission)
        }
    
        hasFeature(user: User, feature: string) {
            return user.features?.includes(feature)
        }
    
        hasPermission(user: User, permission: string) {
            return user.permissions?.includes(permission)
        }
    }
}

export class User {
    fullName?: string
    userName?: string
    avatarUrl?: string
    groupMemberships?: GroupMembership[]
    primaryGroupUuid?: string
    features?: string[]
    permissions?: string[]
}

export class GroupMembership {
    groupUuid!: string
    groupName!: string
    permissions?: string[]
}
